// extracted by mini-css-extract-plugin
module.exports = {"noDataBlock":"NoData_noDataBlock__3Aj7T","noDataText":"NoData_noDataText__2fZqu"};